// Aurora Innovation, Inc. Proprietary and Confidential. Copyright 2026.
import { background } from '../../tokens/themeColors/background';
import { border } from '../../tokens/themeColors/border';
import { icon } from '../../tokens/themeColors/icon';
import { inverseBackground } from '../../tokens/themeColors/inverse';
export var sliderColors = function(mode) {
    var bg = background(mode);
    var bd = border(mode);
    var ic = icon(mode);
    var inverseBg = inverseBackground(mode);
    return {
        background: bg.level300,
        dot: ic.default,
        fill: inverseBg.level0,
        handle: ic.active,
        handleBorder: bd.white,
        disabled: {
            fill: ic.disabled,
            background: bg.state.disabled1
        },
        focus: {
            border: bd.actionBold
        }
    };
};

//# sourceMappingURL=sliderColors.js.map